// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.XDMcG{margin:0}.Qy33P{margin:0 auto;padding:0 0 40px}.jaCVS{min-width:300px}@media only screen and (max-width: 767px){.jaCVS{min-width:0}}.CyLYo{position:relative}.AT0Kq{opacity:.5}.PlZBF{width:100%}.Q7FsJ{height:55px}.Q7FsJ:nth-of-type(even){background-color:#f6f6f7}.LtZnu{color:var(--whitelabeling-primary-color);font-size:14px}._Nlo6{background-color:var(--whitelabeling-toolbar-wrapper-color);border-radius:5px 5px 0 0}@media only screen and (max-width: 767px){._Nlo6{background-color:#fff;border-radius:0}}.k_vm4{background-color:var(--whitelabeling-primary-color)}.phrF5{height:39px}.phrF5>th span,.phrF5>th span:hover,.phrF5>th span:focus,.phrF5>th span:active,.phrF5 .BaNKd{color:#fff !important;font-size:15px;line-height:23px}.phrF5 .BaNKd{font-size:16px}.Dz2Os{background-color:#d8d8d8;background-position:center center;background-size:cover;border-radius:50%;color:var(--whitelabeling-primary-dark-color);font-size:15px;height:40px;text-align:center;text-decoration:none;width:40px}.upsrO{display:flex}.XqX_p{align-items:center}.fTijr,.Ii5ej{color:#4c72bd;font-size:14px;text-decoration:none}.Ii5ej{padding-left:12px}.WFGGI{font-size:17px;font-weight:600;padding-left:12px;text-decoration:none}.J127k{font-size:15px;font-weight:600;max-height:20px;overflow:hidden;text-decoration:none;word-break:break-all}.J127k p{margin:0;padding-left:12px}.n4Bf8{color:rgba(13,43,92,.44);font-size:14px;text-decoration:none}.AYt5b{padding-right:0}@media only screen and (max-width: 767px){.yv1B0{display:none}}@media only screen and (max-width: 767px){.C1tCd{padding-left:13px;padding-right:30px}}.oZ54b{height:24px;width:24px}.qlCyO{height:24px;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "XDMcG",
	"container": "Qy33P",
	"table": "jaCVS",
	"tableWrapper": "CyLYo",
	"loading": "AT0Kq",
	"tableCell": "PlZBF",
	"row": "Q7FsJ",
	"pagination": "LtZnu",
	"toolbarWrapper": "_Nlo6",
	"tableHead": "k_vm4",
	"tableRow": "phrF5",
	"sortIcon": "BaNKd",
	"avatar": "Dz2Os",
	"flex": "upsrO",
	"alignItemsCenter": "XqX_p",
	"discussionAuthor": "fTijr",
	"discussionDate": "Ii5ej",
	"discussionSubject": "WFGGI",
	"discussionMessage": "J127k",
	"tableCellGrey": "n4Bf8",
	"avatarCell": "AYt5b",
	"notDisplayOnMobile": "yv1B0",
	"discussionCell": "C1tCd",
	"lessonIcon": "oZ54b",
	"courseIcon": "qlCyO"
};
module.exports = ___CSS_LOADER_EXPORT___;
